module.exports = __webpack_public_path__ + "img/book_03.10309a31.jpg";